import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Button, Descriptions, message, Modal, Tag, Tooltip} from 'antd';
import copy from 'copy-to-clipboard';

import {CopyOutlined, KeyOutlined} from '@/icons';
import {SecurityTextView} from '@/component';
import AppSelector from '@/page/admin/selector/AppSelector';
import {regenerateSignKey, patchClientApp} from '@/api/clientApps';
import {useClientAppStore} from './context';
import GlobalAllowsMeta from './GlobalAllowsMeta';

import styles from './styles.module.less';

ClientAppMeta.propTypes = {
    clientApp: PropTypes.object,
    reload: PropTypes.func.isRequired,
};

function ClientAppMeta({clientApp, reload}) {
    const AppSelectorRef = useRef();

    const labelStyle = {width: 120, fontWeight: 'bold'};
    const [{hasBindAppApi}] = useClientAppStore();

    function onAppSelClick(appId) {
        return () => {
            AppSelectorRef.current.showModal(appId);
        };
    }

    function onAppSelect(appId) {
        console.log('onAppSelect', appId);
        return patchClientApp(clientApp.id, {appId}).then(() => {
            reload();
            return true;
        });
    }

    function onCopyClick(text) {
        if (copy(text)) {
            message.success('拷贝成功');
        }
    }

    function onRegenSignKeyClick(clientApp) {
        // console.log(clientApp);
        Modal.confirm({
            title: '警告',
            content: `确定重新生成「${clientApp.name}」的 Sign Key？`,
            okText: '重新生成',
            okButtonProps: {danger: true},
            onOk: () => {
                regenerateSignKey(clientApp.id).then(data => {
                    console.log(data);
                    reload();
                });
            },
        });
    }

    return (
        <div className={styles.meta}>
            <Descriptions column={1}>
                <Descriptions.Item label="所属应用" labelStyle={labelStyle}>
                    {clientApp?.wecomAppId ? (
                        <>
                            <Tag
                                color="#2db7f5"
                                onClick={onAppSelClick(clientApp?.appId)}
                                className={styles.clickableTag}
                            >
                                {clientApp?.appName}
                            </Tag>

                            <Tooltip title="点击拷贝企业微信 Id">
                                <Tag
                                    color="cyan"
                                    className={styles.clickableTag}
                                    onClick={() => onCopyClick(clientApp?.wecomAppId)}
                                >
                                    {clientApp?.wecomAppId}
                                </Tag>
                            </Tooltip>
                        </>
                    ) : (
                        <Tooltip title="部分接口需绑定应用，否则该接口无法使用">
                            {/*<Tag color="#cf1322">请关联应用</Tag>*/}
                            <Button
                                type={hasBindAppApi ? 'primary' : 'default'}
                                danger={hasBindAppApi}
                                size="small"
                                onClick={onAppSelClick()}
                            >
                                关联应用
                            </Button>
                        </Tooltip>
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="App Id" labelStyle={labelStyle}>
                    {clientApp?.accessCode}

                    <Tooltip title="拷贝 App Id">
                        <CopyOutlined
                            style={{marginLeft: 16}}
                            onClick={() => onCopyClick(clientApp?.accessCode)}
                        />
                    </Tooltip>
                </Descriptions.Item>
                <Descriptions.Item label="Sign Key" labelStyle={labelStyle}>
                    <SecurityTextView text={clientApp?.accessSignKey} />

                    <Tooltip title="拷贝 Sign Key">
                        <CopyOutlined
                            style={{marginLeft: 16, marginRight: 16}}
                            onClick={() => onCopyClick(clientApp?.accessSignKey)}
                        />
                    </Tooltip>

                    <Tooltip title="重新生成 Sign Key">
                        <KeyOutlined onClick={() => onRegenSignKeyClick(clientApp)} />
                    </Tooltip>
                </Descriptions.Item>

                <Descriptions.Item label="全局可见范围" labelStyle={labelStyle}>
                    <GlobalAllowsMeta clientAppId={clientApp?.id} />
                </Descriptions.Item>
            </Descriptions>

            <AppSelector ref={AppSelectorRef} multi={false} onSelect={onAppSelect} />
        </div>
    );
}

export default ClientAppMeta;
